import cs from "classnames";
import { Heading } from "../Type";
import styles from "./index.module.scss";

const Loader = ({
  heading,
  className,
}: {
  heading?: string;
  className?: string;
}) => {
  return (
    <div className={cs(styles.container, className)}>
      {heading && (
        <Heading size="h4" className={styles.heading}>
          {heading}
        </Heading>
      )}
      <div className={styles.loader} />
    </div>
  );
};

export default Loader;
